import { Injectable } from '@angular/core';
import { isAppThemeKey } from '@shared/constants/app-themes.const';
import { isAppLanguageCode } from '@shared/constants/app-languages.const';
import {
  OrganizationProfileDto,
  UpdateOrganizationProfileRequestDto,
} from '../dtos/organization-profile.dto';
import {
  OrganizationProfile,
  UpdateOrganizationProfile,
} from '../../domain/models/organization-profile.model';

@Injectable()
export class OrganizationProfileMapper {
  public toOrganizationProfile(dto: OrganizationProfileDto): OrganizationProfile {
    return {
      organizationId: dto.OrganizationId,
      name: dto.Name,
      logoUrl: dto.LogoUrl,
      themeKey: isAppThemeKey(dto.ThemeKey) ? dto.ThemeKey : null,
      mobileThemeKey: isAppThemeKey(dto.MobileThemeKey) ? dto.MobileThemeKey : null,
      defaultLanguage: isAppLanguageCode(dto.DefaultLanguage) ? dto.DefaultLanguage : 'es',
      website: dto.Website,
      socialLinksJson: dto.SocialLinksJson,
      contactPhone: dto.ContactPhone,
      contactAddress: dto.ContactAddress,
      contactEmail: dto.ContactEmail,
      emergencyPhone: dto.EmergencyPhone,
      timeZone: dto.TimeZone,
      defaultVatRate: dto.DefaultVatRate,
      openingHoursJson: dto.OpeningHoursJson,
      clientChatAudioEnabled: dto.ClientChatAudioEnabled,
      clientChatFilesEnabled: dto.ClientChatFilesEnabled,
      updatedAtUtc: dto.UpdatedAtUtc,
    };
  }

  public toUpdateRequest(model: UpdateOrganizationProfile): UpdateOrganizationProfileRequestDto {
    return {
      Name: model.name,
      ThemeKey: model.themeKey,
      MobileThemeKey: model.mobileThemeKey,
      DefaultLanguage: model.defaultLanguage,
      Website: model.website,
      SocialLinksJson: model.socialLinksJson,
      ContactPhone: model.contactPhone,
      ContactAddress: model.contactAddress,
      ContactEmail: model.contactEmail,
      EmergencyPhone: model.emergencyPhone,
      TimeZone: model.timeZone,
      DefaultVatRate: model.defaultVatRate,
      OpeningHoursJson: model.openingHoursJson,
      ClientChatAudioEnabled: model.clientChatAudioEnabled,
      ClientChatFilesEnabled: model.clientChatFilesEnabled,
    };
  }
}
